module.exports = __webpack_public_path__ + "static/media/404.8b93428b.gif";